import $ from "jquery";

export default {
    apply($context) {
        $context.find("[data-numeric]").on("keydown", function(e) {
            const key = e.charCode || e.keyCode;
            // Disable Up and Down Arrows on Keyboard
            if (key === 38 || key === 40) {
                e.preventDefault();
            }
        }).on("mousewheel MozMousePixelScroll", function (e) {
            if ($(this).is(":focus")) {
                e.preventDefault();
            }
        });
    },
    destroy($context) {
        $context.find("[data-numeric]").off("keydown").off("mousewheel");
    }
};
